import system from 'system-components'
import { Link } from 'react-static'

const BetterLink = system(
  {
    is: Link,
  },
  'space',
  'color'
)

BetterLink.displayName = 'Link'

export default BetterLink



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Link.js